/* eslint-disable react/no-danger */
import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { Typography } from '../../../../../../components/atoms';

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    fontSize: theme.typography.pxToRem(10),
    marginBottom: 0,
    textAlign: 'center',
    width: 69,
  },
  svg: {
    height: 71,
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

type Props = {
  label: string;
  svg: string | JSX.Element;
};

export function DynamicSvgIcon(props: Props): JSX.Element {
  // Do not pass in 3rd party SVGs here
  const { label, svg } = props;
  const classes = useStyles();

  // Ok to use dangerouslySetInnerHTML here - the SVGs come from a FD CDN so no 3rd party or user has access to them
  return (
    <div className={classes.root}>
      {typeof svg === 'string' ? (
        <div dangerouslySetInnerHTML={{ __html: svg }} />
      ) : (
        <div className={classes.svg}>{svg}</div>
      )}

      <Typography className={classes.label}>{label}</Typography>
    </div>
  );
}
